import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase"; // or wherever your firebase.js lives
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

//ICONS:
import cassettesIcon from './assets/icons/cassettes.png';
import collimatorsProbesIcon from './assets/icons/collimatorsProbes.png';
import fiberPatchPanelsIcon from './assets/icons/Fiber Patch Panels.png';
import fiberCableAssembliesIcon from './assets/icons/fiberCableAssemblies.png';
import fiberTerminalsClosuresIcon from './assets/icons/fiberTerminalsClosures.png';
import framesIcon from './assets/icons/Frames.png';
import lensesIcon from './assets/icons/Lenses.png';
import passiveOpticalComponentsIcon from './assets/icons/PassiveOpticalComponents.png';
import photodetectorsIcon from './assets/icons/photodetectors.png';
import fiberSpliceChasisIcon from './assets/icons/fiberSpliceChasis.png';
import fiberNetworkMonitoringIcon from './assets/icons/fibernetworkmonitoringicon.png'
import allIcon from './assets/icons/all.png';
import transceiver from './assets/icons/transceiver.png'

import planningIcon from './assets/icons/planning.png';
import designIcon from './assets/icons/design.png';
import projectManagementIcon from './assets/icons/project-management.png';
import installationIcon from './assets/icons/installation.png';
import integrationIcon from './assets/icons/integration.png';

import aiIcon from './assets/icons/solutions/ai.webp';
import datacenterIcon from './assets/icons/solutions/datacenter.png';
import centralOfficeIcon from './assets/icons/solutions/centralOffice.png';
import outsidePlantIcon from './assets/icons/solutions/outsidePlant.png';
import fttxIcon from './assets/icons/solutions/fttx.png';
import ruralBroadbandIcon from './assets/icons/solutions/gfRural.png';
import wirelessIcon from './assets/icons/solutions/wireless.png';
import enterpriseIcon from './assets/icons/solutions/enterprise.png';
import medicalImagingIcon from './assets/icons/solutions/medicalImaging.png';
import neuroscienceIcon from './assets/icons/solutions/neuroscience.png';
import specialtyOpticsIcon from './assets/icons/solutions/specialtyOptics.png';


// AI
// Data Center
// Central Office & Headend
// Outside plant
// Fiber Network Monitoring
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const ChevronIcon = ({ color, open }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    {open ? (
      <path d="M6 15l6-6 6 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    ) : (
      <path d="M6 9l6 6 6-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    )}
  </svg>
);

const solutions = [
  // {
  //   name: "AI",
  //   slug: "ai",
  //   solutionImage: "/images/solutions/ai.jpg",
  //   solutionHeading: "A New Generation of Connectivity for AI",
  //   solutionDescription: "Every leap forward, every scalable solution, every AI-driven revolution relies on the power of fiber optics at its core"
  // },
    {
    name: "AI",
    slug: "ai",
    solutionImage: "/images/solutions/ai.jpg",
    solutionHeading: "Your home for AI data center fiber infastructure",
    solutionDescription: "Every leap forward, every scalable solution, every AI-driven innovation relies on the power of fiber optics."
  },
  {
    name: "Data Center",
    slug: "datacenter",
    solutionImage: "/images/solutions/datacenter.jpg",
    solutionHeading: "Designing and developing data centers for what is not yet imagined.",
    solutionDescription: "With the potential to be the transformative technology of our generation, we’re creating DCI solutions to ensure AIs potential and impact are limitless"
  },
  {
    name: "Central Office & Headend",
    slug: "central-office",
    solutionImage: "/images/solutions/centralOffice.jpg",
    solutionHeading: "Next-generation fiber connectivity solution",
    solutionDescription: "Where modern networks converge and tomorrow's service delivery begins"
  },
  {
    name: "Outside Plant",
    slug: "outside-plant",
    solutionImage: "/images/solutions/outsidePlant.png",
    solutionHeading: "CONNECTED COMMUNITIES RELY ON OUTSIDE PLANT SOLUTIONS",
    solutionDescription: "Fiber optics are connecting communities and transforming the way we live. If you are ready to deliver more and do more for your community, we can help."
  },
  {
    name: "FTTx & MDU",
    slug: "fttx",
    solutionImage: "/images/solutions/ftth.jpg",
    solutionHeading: "Fiber First. Everywhere It Counts",
    solutionDescription: "Empowering fiber access for homes, buildings, and communities"
  },
  {
    name: "Rural Broadband",
    slug: "rural-broadband",
    solutionImage: "/images/solutions/ruralBroadband.jpeg",
    solutionHeading: "A Smarter Path to Rural Broadband",
    solutionDescription: "Transforming connectivity and communities with fiber-first solutions"
  },
  {
    name: "Wireless",
    slug: "wireless",
    solutionImage: "/images/solutions/wireless.jpg",
    solutionHeading: "A New Era of Wireless Connectivity",
    solutionDescription: "Fiber optics powering the future of wireless networks"
  },
  {
    name: "Enterprise",
    slug: "enterprise",
    solutionImage: "/images/solutions/enterprise.jpeg",
    solutionHeading: "Unlock Your Enterprise's Potential with Next-Gen Fiber Solutions",
    solutionDescription: "Seamless Connectivity for a Fast-Paced Digital World"
  },
  {
    name: "Medical Imaging",
    slug: "medical-imaging",
    solutionImage: "/images/solutions/medicalImaging.jpeg",
    solutionHeading: "Sharper Medical Images Begin with Superior Optics",
    solutionDescription: "Where innovation meets precision"
  },
  {
    name: "Neuroscience",
    slug: "neuroscience",
    solutionImage: "/images/solutions/neuroscience.jpeg",
    solutionHeading: "Superior Optics for Revolutionary Neuroscience",
    solutionDescription: "Where scientific innovation meets unparalleled clarity, setting the stage for transformative discoveries"
  },{
    name: "Specialty Optics",
    slug: "specialty-optics",
    solutionImage: "/images/solutions/specialtyOptics.jpeg",
    solutionHeading: "See Further, Discover Faster: Specialty Optics Engineered for Innovation",
    solutionDescription: "Delivering high-performance and driving breakthroughs"
  },
];

const services = [
  // {
  //   name: "AI",
  //   slug: "ai",
  //   solutionImage: "/images/solutions/ai.jpg",
  //   solutionHeading: "A New Generation of Connectivity for AI",
  //   solutionDescription: "Every leap forward, every scalable solution, every AI-driven revolution relies on the power of fiber optics at its core"
  // },
  {
    name: "Pre-deployment",
    anchor: "pre-deployment",
    solutionImage: "/images/services/image2.jpg",
    solutionHeading: "Planning",
    solutionDescription: "Our methodology begins with a deep dive into your AI objectives and IT priorities"
  },
  {
    name: "Project management",
    anchor: "project-management",
    solutionImage: "/images/services/image3.jpg",
    solutionHeading: "Design",
    solutionDescription: "Our Network Design Services for AI Data Centers focus on building agile, high-performance fiber networks that scale with AI demands"
  },
  {
    name: "Low voltage cabling (LVC)",
    anchor: "lvc",
    solutionImage: "/images/services/image5.jpg",
    solutionHeading: "Project Management",
    solutionDescription: "As industry trailblazers, we know resources can be strapped, and we are here to help"
  },
  {
    name: "Fiber splicing for ISP/OSP",
    anchor: "fiber-splicing",
    solutionImage: "/images/services/image6.jpg",
    solutionHeading: "Installation",
    solutionDescription: "Our network installation services are executed by seasoned network installers with deep fiber infrastructure expertise"
  },
  {
    name: "Post deployment",
    anchor: "post-deployment",
    solutionImage: "/images/services/image7.jpg",
    solutionHeading: "Integration",
    solutionDescription: "Our Integration Services streamline complex ecosystems by unifying fiber, compute, and cooling systems into a seamless workflow"
  }
];



function Navbar() {
  const navigate = useNavigate();

  const [activeMegaMenu, setActiveMegaMenu] = useState(null); // Only for mega menu items
  const [arrowLeft, setArrowLeft] = useState(null);
  const [megaMenuTop, setMegaMenuTop] = useState(145);
  const [productFamilies, setProductFamilies] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [productsBySubFamily, setProductsBySubFamily] = useState({});
  const [allProducts, setAllProducts] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false); //mobile
  const [openDropdown, setOpenDropdown] = useState(null); //mobile
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [selectedService, setSelectedService] = useState(null);


    
  const productsRef = useRef();
  const solutionsRef = useRef();
  const resourcesRef = useRef();
  const companyRef = useRef();  

  const location = useLocation();

  const toggleDropdown = (menu) => {
    setOpenDropdown(prev => prev === menu ? null : menu);
  };

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  if (!activeMegaMenu || isMobile) return;

  const updateMegaMenuPosition = () => {
    const navbar = document.querySelector(".navbar");
    if (!navbar) return;

    const rect = navbar.getBoundingClientRect();
    setMegaMenuTop(Math.max(0, rect.bottom));
  };

  updateMegaMenuPosition();

  window.addEventListener("resize", updateMegaMenuPosition);

  return () => {
    window.removeEventListener("resize", updateMegaMenuPosition);
  };
}, [activeMegaMenu, isMobile]);

  useEffect(() => {
    // Auto-close mega menu when path changes
    setActiveMegaMenu(null);
    setSelectedFamily(null);
    setProductsBySubFamily({});
  }, [location.pathname]);

  const familyIcons = {
    "Fiber Cable Assemblies": fiberCableAssembliesIcon,
    "Fiber Panels": fiberPatchPanelsIcon,
    "Cassettes": cassettesIcon,
    "Fiber Terminals & Closures": fiberTerminalsClosuresIcon,
    //"Fiber Splice Chassis": fiberSpliceChasisIcon,
    "Fiber Network Monitoring": fiberNetworkMonitoringIcon,
    "Frames": framesIcon, // assuming "Frames" = "Fiber Distribution Frames"
    "Passive Optical Components": passiveOpticalComponentsIcon,
    "Photodetectors": photodetectorsIcon,
    "Collimators & Probes": collimatorsProbesIcon,
    "Lenses": lensesIcon,
    "All Products": allIcon,
    "Transceivers":  transceiver
  };

    const serviceIcons = {
    "Pre-deployment": planningIcon,
    "Project management": designIcon,
    "Low voltage cabling (LVC)": projectManagementIcon,
    "Fiber splicing for ISP/OSP": installationIcon,
    "Post deployment": integrationIcon
  };

  const solutionIcons = {
  "AI": aiIcon,
  "Data Center": datacenterIcon,
  "Central Office & Headend": centralOfficeIcon,
  "Outside Plant": outsidePlantIcon,
  "FTTx & MDU": fttxIcon,
  "Rural Broadband": ruralBroadbandIcon,
  "Wireless": wirelessIcon,
  "Enterprise": enterpriseIcon,
  "Medical Imaging": medicalImagingIcon,
  "Neuroscience": neuroscienceIcon,
  "Specialty Optics": specialtyOpticsIcon,
};


  const productFamilyOrder = [
  "Fiber Cable Assemblies",
  "Fiber Panels",
  "Cassettes",
  "Fiber Terminals & Closures",
  //"Fiber Splice Chassis",
  "Fiber Network Monitoring",
  "Frames", // or "Fiber Distribution Frames"
  "Transceivers",
  "Passive Optical Components",
  "Photodetectors",
  "Collimators & Probes",
  "Lenses",
  "Instruments",
  "Services",
  "All Products"
];


useEffect(() => {
  document.body.classList.toggle('menu-open', menuOpen);
}, [menuOpen]);

const orderedFamilies = productFamilyOrder.filter(f => productFamilies.includes(f));

    
const preloadImage = (src) => {
  if (!src) return;
  const img = new Image();
  img.src = src;
};

  useEffect(() => {
    const fetchFamilies = async () => {
      const querySnapshot = await getDocs(collection(db, "products"));
      const products = querySnapshot.docs.map((doc) => doc.data());
  
      setAllProducts(products); // ✅ still store in state

      products.forEach((p) => {
        if (p.image && p.image.trim() !== "") {
          preloadImage(p.image);
        }
      });
  
      const families = Array.from(
        new Set(
          products
            .map((p) => p.productFamily?.trim())
            .filter((val) => val && val.length > 0)
        )
      ).sort();
  
      setProductFamilies(families);
      console.log("Loaded product families:", families); // 🔍 DEBUG
    };
  
    fetchFamilies();
  }, [location.pathname]);
  

  //fix issue with scrolling on navbar scrolling page:
useEffect(() => {
  if (activeMegaMenu) {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollBarWidth}px`;
    document.body.style.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--body-bg-color');
  } else {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.style.backgroundColor = "";
  }
  return () => {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.style.backgroundColor = "";
  };
}, [activeMegaMenu]);

  
  return (
    <>
  <div className="navbar">
  <Link to="/">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FGoFoton%20Logo-k%20(R).png?alt=media&token=6fa4c257-8569-4f86-af93-320f2b64a527"
      alt="GoFoton Logo"
      className="logo"
      style={{ cursor: 'pointer' }}
      onClick={() => setMenuOpen(prev => !prev)}
    />
  </Link>
    <button className="hamburger" onClick={() => setMenuOpen(prev => !prev)}>
      ☰
    </button>
   <ul className={`nav-items ${menuOpen ? 'open' : ''}`}>
      <li
      ref={productsRef}
        className={`nav-item dropdown ${openDropdown === 'Products' ? 'open' : ''}`}
        onClick={() => {
          if (isMobile) {
            toggleDropdown('Products');
          }
        }}
        onMouseEnter={() => {
          if (!isMobile) {
            const rect = productsRef.current.getBoundingClientRect();
            setArrowLeft(rect.left + rect.width / 2);
            setActiveMegaMenu('Products');
            setSelectedService(null)
          }
        }}
      >

        {/* PRODUCTS */}
  {isMobile ? (<div style={{ marginTop: 20, backgroundColor: openDropdown === 'Products' ? '#D94829' : 'white'}} className="nav-row products">
    <span style={{color: openDropdown === 'Products' ? 'white' : 'black', fontSize: 20}}>Products</span>
<span className="chevron-nav"><ChevronIcon color={openDropdown === 'Products' ? 'white' : 'black'} open={openDropdown === 'Products'} /></span>
</div>
) : <p>Products</p>}
  

{isMobile ? (
  <ul className="dropdown-menu mobile-dropdown">
    {openDropdown === 'Products' && (
      <>
        <li key="all-products">
          <a href="/products">All Products</a>
        </li>
        <li key="services">
          <a href="/services">Services</a>
        </li>
        {orderedFamilies.map((family, idx) => (
          <li key={idx}>
            <a href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}>
              {family}
            </a>
          </li>
        ))}
      </>
    )}
  </ul>
) : null}
      </li>


<li className="nav-item dropdown">
  {isMobile ? (
    <a
      href="/services"
      className="nav-row"
      style={{
        fontSize: 20,
        color: 'black',
        textDecoration: 'none'
      }}
    >
      <span style={{color: openDropdown === 'Services' ? 'white' : 'black', fontSize: 20 }}>Services</span>
      {/* <span className="chevron-nav">
        <ChevronIcon color="black" open />
      </span> */}
    </a>
  ) : (
    <a
      href="/services"
      style={{
        textDecoration: 'none',
        color: 'inherit'
      }}
      onMouseEnter={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setArrowLeft(rect.left + rect.width / 2);
        setActiveMegaMenu('Services');
        setSelectedService(null);
      }}
    >
      <p>Services</p>
    </a>
  )}
</li>




      <li
      ref={solutionsRef}
        className={`nav-item dropdown ${openDropdown === 'Solutions' ? 'open' : ''}`}
        onClick={() => {
          if (isMobile) {
            toggleDropdown('Solutions');
          }
        }}
        onMouseEnter={() => {
          if (!isMobile) {
          if (!isMobile) {
            const rect = solutionsRef.current.getBoundingClientRect();
            setArrowLeft(rect.left + rect.width / 2);
            setActiveMegaMenu('Solutions');
            setSelectedService(null)
          }
        }}}
      >
        {/* SOLUTIONS */}
  {isMobile ? (<div style={{ marginTop: -5, backgroundColor: openDropdown === 'Solutions' ? '#D94829' : 'white'}} className="nav-row">
    <span style={{color: openDropdown === 'Solutions' ? 'white' : 'black', fontSize: 20 }}>Solutions</span>
<span className="chevron-nav"><ChevronIcon color={openDropdown === 'Solutions' ? 'white' : 'black'} open={openDropdown === 'Solutions'} /></span>
  </div>) :
  <p>Solutions</p>}

        {isMobile ? (
          <ul className="dropdown-menu mobile-dropdown">
            {openDropdown === 'Solutions' &&
              solutions.map((sol, idx) => (
                <li key={idx}>
                  <a href={`/solutions/${sol.slug}`}>
                    {sol.name}
                  </a>
                </li>
              ))
            }
          </ul>
        ) : null}
      </li>

<li
  className={`nav-item dropdown ${openDropdown === 'Resources' ? 'open' : ''}`}
  onClick={() => {
    if (isMobile) toggleDropdown('Resources');
  }}
  onMouseEnter={() => {
    if (!isMobile) setActiveMegaMenu(null); // optional: closes Products/Solutions
  }}
>
  {isMobile ? (
    <div
      className="nav-row"
      style={{
        marginTop: -5,
        backgroundColor: openDropdown === 'Resources' ? '#D94829' : 'white',
        color: openDropdown === 'Resources' ? 'white' : 'black',
        fontSize: 20
      }}
    >
      Resources
      <span className="chevron-nav">
       <ChevronIcon
          color={openDropdown === 'Resources' ? 'white' : 'black'}
          open={openDropdown === 'Resources'}
        />
      </span>
    </div>
  ) : (
    <p>Resources</p>
  )}

  {/* MOBILE DROPDOWN */}
  {isMobile && openDropdown === 'Resources' && (
    <ul className="dropdown-menu mobile-dropdown">
      <li><a href="/knowledge-center">Knowledge Center</a></li>
      <li><a href="/part-lookup">Part Number Lookup</a></li>
      <li><a href="/bead">BEAD & BABA</a></li>
      <li><a href="/partners">Partners</a></li>
      <li><a href="/contact-us">Contact Us</a></li>
    </ul>
  )}

  {/* DESKTOP DROPDOWN */}
  {!isMobile && (
    <ul className="dropdown-menu">
      <li><a href="/knowledge-center">Knowledge Center</a></li>
      <li><a href="/part-lookup">Part Number Lookup</a></li>
      <li><a href="/bead">BEAD & BABA</a></li>
      <li><a href="/partners">Partners</a></li>
      <li><a href="/contact-us">Contact Us</a></li>
    </ul>
  )}
</li>



<li
  className={`nav-item dropdown ${openDropdown === 'Company' ? 'open' : ''}`}
  onClick={() => {
    if (isMobile) toggleDropdown('Company');
  }}
  onMouseEnter={() => {
    if (!isMobile) setActiveMegaMenu(null); // closes other menus if needed
  }}
>
  {/* Header Row */}
  {isMobile ? (
    <div
      className="nav-row"
      style={{
        marginTop: -5,
        backgroundColor: openDropdown === 'Company' ? '#D94829' : 'white'
      }}
    >
      <span
        style={{
          color: openDropdown === 'Company' ? 'white' : 'black',
          fontSize: 20
        }}
      >
        Company
      </span>
      <span className="chevron-nav">
        <ChevronIcon
          color={openDropdown === 'Company' ? 'white' : 'black'}
          open={openDropdown === 'Company'}
        />
      </span>
    </div>
  ) : (
    <p>Company</p>
  )}

  {/* MOBILE DROPDOWN */}
  {isMobile && openDropdown === 'Company' && (
    <ul className="dropdown-menu mobile-dropdown">
      <li><a href="/about">About Us</a></li>
      <li><a href="/leadership">Leadership</a></li>
      <li><a href="/news">News & Events</a></li>
      <li><a href="/careers">Careers</a></li>
    </ul>
  )}

  {/* DESKTOP DROPDOWN */}
  {!isMobile && (
    <ul className="dropdown-menu">
      <li><a href="/about">About Us</a></li>
      <li><a href="/leadership">Leadership</a></li>
      <li><a href="/news">News & Events</a></li>
      <li><a href="/careers">Careers</a></li>
    </ul>
  )}
</li>





    </ul>
  </div>

  {/* PRODUCTS MEGA MENU */}

  {activeMegaMenu === "Products" && (
    <>
      {!isMobile && (<div className="arrow-up" style={{ left: `${arrowLeft}px`, top: `${Math.max(0, megaMenuTop - 10)}px` }} />)}

      <div className="mega-menu"
style={{ top: `${megaMenuTop}px`, maxHeight: `calc(100vh - ${megaMenuTop}px)` }}
        onMouseLeave={() => {
          setActiveMegaMenu(null);
          setSelectedFamily(null);
          setProductsBySubFamily({});
      }}>





<div className="left-col">

{orderedFamilies.map((family, idx) => (
  <div
    key={idx}
    className={`family-item ${selectedFamily === family ? 'active' : ''}`}
    onMouseEnter={() => {
      setSelectedFamily(family);
const ranked = allProducts
  .filter(p => p.productFamily?.trim() === family)
  .sort((a, b) => (a.rank || 9999) - (b.rank || 9999)); // Sort by rank ascending, fallback to 9999 if missing

setProductsBySubFamily({ all: ranked });
    }}
    onClick={() => {
      setActiveMegaMenu(null);
      setSelectedFamily(null);
      setProductsBySubFamily({});
      navigate(`/${family.toLowerCase().replace(/\s+/g, '-')}`);
    }}
  >
    <div
      className={`family-icon-mask ${selectedFamily === family ? 'active' : ''}`}
      style={{
        WebkitMaskImage: `url(${familyIcons[family]})`,
        maskImage: `url(${familyIcons[family]})`
      }}
    ></div>
    {family}
  </div>
))}

<div
  className="family-item"
  onMouseEnter={() => {
    setSelectedFamily(null); // ✅ clear the hover highlight!
  }}
  onClick={() => {
    setActiveMegaMenu(null);
    setSelectedFamily(null);
    setProductsBySubFamily({});
    navigate("/services");
  }}
>
  <div
    className="family-icon-mask"
    style={{
      WebkitMaskImage: `url(images/icons/services.png)`,
      maskImage: `url(images/icons/services.png)`
    }}
  ></div>
  Services
</div>


{/* {orderedFamilies.map((family, idx) => (
  <div
    key={idx}
    className={`family-item ${selectedFamily === family ? 'active' : ''}`}
    onMouseEnter={() => {
      setSelectedFamily(family);
      const grouped = {};
      allProducts
        .filter(p => p.productFamily?.trim() === family)
        .forEach(p => {
          const l2 = p.subFamily || "Other";
          if (!grouped[l2]) grouped[l2] = [];
          grouped[l2].push(p);
        });
      setProductsBySubFamily(grouped);
    }}
    onClick={() => {
      setActiveMegaMenu(null);
      setSelectedFamily(null);
      setProductsBySubFamily({});
      navigate(`/${family.toLowerCase().replace(/\s+/g, '-')}`);
    }}
  >
    <div
      className={`family-icon-mask ${selectedFamily === family ? 'active' : ''}`}
      style={{
        WebkitMaskImage: `url(${familyIcons[family]})`,
        maskImage: `url(${familyIcons[family]})`
      }}
    ></div>
    {family}
  </div>
))} */}
<div className="buttonContainer">

          {/* Add All Products Button */}
          {/* <div className="all-products-button" 
          onClick={() => {
            setActiveMegaMenu(null);
            setSelectedFamily(null);
            setProductsBySubFamily({});
            navigate('/products');
          }}
          
          >
          All Products
          </div> */}

          {/* <div className="all-products-button" 
          onClick={() => {
            setActiveMegaMenu(null);
            setSelectedFamily(null);
            setProductsBySubFamily({});
            navigate('/services');
          }}
          
          >
          Services
          </div> */}
          </div>
        </div>

        <div className="right-col">
          {!selectedFamily && (
            <div
              className="solution-image-wrapper"
              style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(255,255,255,0)), url("https://gofoton.com/images/services/image1.jpg")`,
                backgroundSize: 'cover, cover',
                backgroundPosition: 'center, center',
                backgroundRepeat: 'no-repeat, no-repeat'
              }}
            >

            <div className="solution-overlay">
              <h3>Find the optical solutions for you</h3>
              <p>Explore our products</p>
              <button
                className="cta-button"
                onClick={() => {
                  setActiveMegaMenu(null);
                  setSelectedSolution(null);
                  setProductsBySubFamily({});
                  navigate('/products');
                }}
              >
                All Products
              </button>
            </div>
          </div>
        )}
          {Object.entries(productsBySubFamily).map(([subFamily, products]) => (
            <div key={subFamily} className="subfamily-block">
              {/* <h4>{subFamily}</h4> */}
              <div className="products-grid-nav">
                {products.map((p) => (
                <div
                  key={p.slug || p.product}
                  className="product-box"
                    onClick={() => {
                      setActiveMegaMenu(null);
                      setSelectedFamily(null);
                      setProductsBySubFamily({});
                      navigate(`/${p.slug}`);
                    }}>
                <img
                  src={p.image && p.image.trim() !== "" ? p.image : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222"}
                  alt={p.product}
                  className="product-image"
                  loading="eager"
                  decoding="async"
                />

              {p.product === "Fiber Slack Panel" && (<div className="product-badge">New</div>)}
              {p.product === "PEACOC® Any Port Panel" && (<div className="product-badge">New</div>)}
              {p.product === "EKO Intelligent Patch Panel" && (<div className="product-badge">New</div>)}
              {p.product === "PEACOC® 360-144 Spooling Patch Panel" && (<div className="product-badge">New</div>)}
              <div className="product-name">{p.product}</div>
            </div>

                ))}
              </div>
            </div>
          ))}
        </div>

    </div>
    <div className="mega-overlay" style={{ top: `${megaMenuTop}px`, height: `calc(100vh - ${megaMenuTop}px)` }} />
  </>
)}


  {/* SOLUTIONS MEGA MENU */}

  {/* 
  
// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment
  
  */}



  {activeMegaMenu === "Services" && (
    <>
      {!isMobile && (<div className="arrow-up" style={{ left: `${arrowLeft}px`, top: `${Math.max(0, megaMenuTop - 10)}px` }} />)}

      <div className="mega-menu"
style={{ top: `${megaMenuTop}px`, maxHeight: `calc(100vh - ${megaMenuTop}px)` }}
        onMouseLeave={() => {
          setActiveMegaMenu(null);
          setSelectedFamily(null);
          setProductsBySubFamily({});
      }}>

<div className="left-col">
        {services.map((sol, idx) => (
          <div
            key={idx}
            className={`family-item ${selectedSolution?.name === sol.name ? 'active' : ''}`}
            onMouseEnter={() => setSelectedService(sol)}
            onClick={() => {
              setActiveMegaMenu(null);
              setSelectedService(null);
              navigate(`/services#${sol.anchor}`);
            }}
          >
            <div
              className={`family-icon-mask ${selectedSolution === sol.name ? 'active' : ''}`}
              style={{
                WebkitMaskImage: `url(${serviceIcons[sol.name]})`,
                maskImage: `url(${serviceIcons[sol.name]})`
              }}
            ></div>
            {sol.name}
          </div>
        ))}
      </div>

      <div className="right-col solution-preview">
        {!selectedService && (
            <div
              className="solution-image-wrapper"
              style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(255,255,255,0)), url("http://gofoton.com/images/services/ServicesImage.png")`,
                backgroundSize: 'cover, cover',
                backgroundPosition: 'center, center',
                backgroundRepeat: 'no-repeat, no-repeat'
              }}
            >

            <div className="solution-overlay">
              <h3>Turnkey services from design to deployment</h3>
              <p>Explore our services</p>
              <button
                className="cta-button"
                onClick={() => {
                  setActiveMegaMenu(null);
                  setSelectedService(null);
                  setProductsBySubFamily({});
                  navigate('/services');
                }}
              >
                All Services
              </button>
            </div>
          </div>
        )}
        {selectedService && (
          <div
            className="solution-image-wrapper"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(255,255,255,0)), url(${selectedService.solutionImage})`
            }}
          >
            <div className="solution-overlay">
              <h3>{selectedService.solutionHeading}</h3>
              <p>{selectedService.solutionDescription}</p>
              <button
                className="cta-button"
                onClick={() => {
                  setActiveMegaMenu(null);
                  setSelectedService(null);
                  navigate(`/services#${selectedService.anchor}`);
                }}
              >
                Learn More
              </button>
            </div>
          </div>
        )}
    </div>
    </div>
    <div className="mega-overlay" style={{ top: `${megaMenuTop}px`, height: `calc(100vh - ${megaMenuTop}px)` }} />
  </>
)}


  {/* SOLUTIONS MEGA MENU */}

  {/* 
  
// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment
  
  */}



{activeMegaMenu === "Solutions" && (
  <>
    {!isMobile && (<div className="arrow-up" style={{ left: `${arrowLeft}px`, top: `${Math.max(0, megaMenuTop - 10)}px` }} />)}
    <div
      className="mega-menu"
style={{ top: `${megaMenuTop}px`, maxHeight: `calc(100vh - ${megaMenuTop}px)` }}
      onMouseLeave={() => {
        setActiveMegaMenu(null);
        setSelectedSolution(null);
      }}
    >
      <div className="left-col">
        {solutions.map((sol, idx) => (
          <div
            key={idx}
            className={`family-item ${selectedSolution?.name === sol.name ? 'active' : ''}`}
            onMouseEnter={() => setSelectedSolution(sol)}
            onClick={() => {
              setActiveMegaMenu(null);
              setSelectedSolution(null);
              navigate(`/solutions/${sol.slug}`);
            }}
          >
            {solutionIcons[sol.name] && (
              <div
                className={`family-icon-mask ${selectedSolution?.name === sol.name ? 'active' : ''}`}
                style={{
                  WebkitMaskImage: `url(${solutionIcons[sol.name]})`,
                  maskImage: `url(${solutionIcons[sol.name]})`
                }}
              />
            )}
            {sol.name}

          </div>
        ))}
      </div>

      <div className="right-col solution-preview">
        {!selectedSolution && (
            <div
              className="solution-image-wrapper"
              style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(255,255,255,0)), url("https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FScreenshot%202025-10-22%20at%2009.51.38.png?alt=media&token=43c96d90-21d2-415d-a88f-e94c0ff13b3d")`,
                backgroundSize: 'cover, cover',
                backgroundPosition: 'center, center',
                backgroundRepeat: 'no-repeat, no-repeat'
              }}
            >

            <div className="solution-overlay">
              <h3>Solutions for the world's most critical environments</h3>
              <p>Explore our products</p>
              <button
                className="cta-button"
                onClick={() => {
                  setActiveMegaMenu(null);
                  setSelectedSolution(null);
                  setProductsBySubFamily({});
                  navigate('/solutions');
                }}
              >
                All Products
              </button>
            </div>
          </div>
        )}
        {selectedSolution && (
          <div
            className="solution-image-wrapper"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(255,255,255,0)), url(${selectedSolution.solutionImage})`
            }}
          >
            <div className="solution-overlay">
              <h3>{selectedSolution.solutionHeading}</h3>
              <p>{selectedSolution.solutionDescription}</p>
              <button
                className="cta-button"
                onClick={() => {
                  setActiveMegaMenu(null);
                  setSelectedSolution(null);
                  navigate(`/solutions/${selectedSolution.slug}`);
                }}
              >
                Learn More
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
    <div className="mega-overlay" style={{ top: `${megaMenuTop}px`, height: `calc(100vh - ${megaMenuTop}px)` }} />
  </>
)}


</>

  );
}

export default Navbar;
